import { render, staticRenderFns } from "./SidebarOpen.vue?vue&type=template&id=32bda534"
import script from "./SidebarOpen.vue?vue&type=script&lang=js"
export * from "./SidebarOpen.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports